import { TERMS_COPY } from '../copy/terms-copy'
import { TermsAgreement } from './terms-agreement'

// The first onboarding step for a new account, before its role is picked. The onboarding flow shows it in the sign-in
// layout and takes it away once the terms are recorded.
export function TermsAcceptanceStep() {
  return (
    <section aria-label={TERMS_COPY.title} className="space-y-6">
      <header className="space-y-2">
        <h2 className="text-2xl font-semibold">{TERMS_COPY.title}</h2>
        <p className="text-sm text-muted-foreground">{TERMS_COPY.intro}</p>
      </header>
      <TermsAgreement />
    </section>
  )
}
